/**============================================================
*   [Class] アニメーション：SVGテキストストローク
============================================================*/
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {CustomEase} from 'gsap/CustomEase';
gsap.registerPlugin(ScrollTrigger,CustomEase);

export default class AnimateTextStroke {
  constructor(
    target,
    key,
    line=1
  )
  {
    this.target = target;
    this.targets = this.target.querySelectorAll('tspan');
    this.fillColorTarget = this.target.querySelector('.js-animate-text-stroke__fill-color');
    this.key = key;
    this.line = line;
    this.line = target.dataset.svgStroke ? target.dataset.svgStroke : false;

    let tl = gsap.timeline({
      paused: true
    });

    if(this.fillColorTarget) {
      //fillColor専用のSVGが含まれる場合のTL
      const strokes = this.target.querySelector('.js-animate-text-stroke__stroke').querySelectorAll('tspan');
      const fillTargets = this.fillColorTarget.querySelectorAll('tspan');
      tl.to(fillTargets,
        {
          fillOpacity: 0.15,
          duration: 0.6,
        }
      ).to(strokes,
        {
          strokeDashoffset: 0,
          duration: 3,
        }
      ).to(this.fillColorTarget,
        {
          x: 4,
          y: 4,
          duration: 0.8,
        }
      , '-=2')
    }else if(this.line == 'line'){
      //ラインのみの場合のTL
      tl.to(this.targets,
        {
          strokeDashoffset: 0,
          duration: 3,
        }
      )
    }else{
      //白ラインのみの場合のTL
      tl.to(this.targets,
        {
          fillOpacity: 0.3,
          duration: 0.6,
        }
      ).to(this.targets,
        {
          strokeDashoffset: 0,
          duration: 3,
        }
      ).to(this.targets,
        {
          fillOpacity: 0,
          duration: 0.4,
        }
      , '-=2')
    }

    ScrollTrigger.create({
      trigger: this.target,
      start: 'top 80%',
      onEnter: () => {
        tl.play();
      },
    });
  }
}
